import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import _ from 'lodash';
import classnames from 'classnames/bind';
import ClickOut from 'react-click-out';
import {
  ICountry,
  IState,
  LocationCategory,
  Replacement,
} from '../../../../interface';
import actions from '../../../../redux/actions';
import style from './index.module.scss';
import localesReplacement from '../../../../utils/localesReplacement';
import { RETAIL_OUTLET } from '../../../../constants';

const cx = classnames.bind(style);

interface IProps {
  state: IState;
  sort: string;
  replacements: Replacement;
  setAccord: (value: boolean) => void;
  setSort: (value: string) => void;
  country: ICountry;
  locationCategoriesList: LocationCategory[] | null;
  accord: boolean;
}

//Sort dropdown and map view(only for mobile) component with redu
export const SortSection = (props: IProps) => {
  const {
    state,
    sort,
    replacements,
    setAccord,
    setSort,
    country,
    locationCategoriesList,
    accord,
  } = props;
  const [dropVisible, setdropVisible] = useState<boolean>(false);
  const sorts = [
    { label: 'Name', value: 'name' },
    { label: 'Distance', value: 'distanceInMiles' },
  ];
  //Change by dropdown options is selectd
  const selectSort = (value: string) => {
    setSort(value);
  };
  const label = _.isEmpty(_.find(sorts, ['value', sort]))
    ? 'Name'
    : _.find(sorts, ['value', sort])?.label;

  const locCatNames = _.map(
    state.filter.locationCategories,
    (lc) =>
      _.find(locationCategoriesList, (l) => _.isEqual(lc, l.id.toString()))
        ?.name,
  );
  return (
    <div className={cx('section')}>
      {/* Sort dropdown */}

      <ClickOut className='click-out' onClickOut={() => setdropVisible(false)}>
        <div
          className={cx('sort-section', { on: dropVisible })}
          onClick={() => setdropVisible(!dropVisible)}
        >
          <strong>{localesReplacement(replacements, 'Sort by')} :</strong>
          <div className={cx('selected')}>
            <span className={cx('selected-text')}>
              {localesReplacement(replacements, label as string)}
            </span>
            {/* layout of dropdown */}
            <div className={cx('flyout', { visible: dropVisible })}>
              <div className={cx('label')}>
                {localesReplacement(replacements, 'Sort by')}
              </div>
              <ul>
                {_.map(sorts, (obj, index) => (
                  <li
                    key={index}
                    className={cx({ active: _.isEqual(sort, obj.value) })}
                    onClick={() => selectSort(obj.value)}
                  >
                    <span className='link' role='link'>
                      {localesReplacement(replacements, obj.label)}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
            <div
              className={cx('mask', { visible: dropVisible })}
              onClick={() => setdropVisible(false)}
            ></div>
          </div>
        </div>
      </ClickOut>
      {/** trigger map view */}
      {!!country.isoCode && (
        <>
          {_.includes(locCatNames, RETAIL_OUTLET) ? null : (
            <div className={cx('view-section')}>
              <span
                className={`button ${cx('map-view', { 'on': accord })}`}
                role='button'
                onClick={() => setAccord(!accord)}
              >
                {localesReplacement(replacements, 'Map view')}
              </span>
            </div>
          )}
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state: IState) => ({
  state: state,
  sort: state.sort,
  replacements: state.replacements,
  country: state.country,
  locationCategoriesList: state.locationCategoriesList,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setSort: (value: string) => dispatch(actions.setSort(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SortSection);
